import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import RateReviewIcon from '@mui/icons-material/RateReview';
import React from "react";
import Rating from "@mui/material/Rating";
import { RightioWBSAPIModelsJobsLast } from "@utils/apis/wbs/model";

const name = "FeedbackList";

interface FeedbackListProps {
    jobReviews: RightioWBSAPIModelsJobsLast[]
}

const FeedbackList: React.FC<FeedbackListProps> = ({ jobReviews }) => {
    const [review, setReview] = React.useState<any | undefined>(undefined);

    React.useEffect(() => {
        const review = jobReviews.find(jr => jr.jobReviews?.score)?.jobReviews;
        setReview(review);
    }
        , [jobReviews]);
    return (
        <Stack sx={{ maxHeight: 215, overflowY: "auto" }}>
            <Stack sx={{ textAlign: "center", p: 1 }} direction="row" justifyContent="center" gap={1} >
                <Typography style={{ textAlign: "center", marginBottom: "-5px" }}>FEEDBACK</Typography>
                <RateReviewIcon />
            </Stack>
            <Stack >
                <Typography component="legend">{review?.comments}</Typography>
                <Stack key={review?.comments} alignItems="center" sx={{ p: 1 }}>
                    <Rating name="read-only" value={(review?.score || 0) / 2.0} readOnly precision={0.5} max={5} />
                </Stack>
            </Stack>
        </Stack>)
}

FeedbackList.displayName = name;

export default React.memo(FeedbackList);